export const TABS = ['applyProcess', 'validResult']
